import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
  const page = {
    backgroundColor: "#05070a",
    color: "#ffffff",
    minHeight: "100vh",
    paddingTop: "120px",
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    overflowX: "hidden",
  };

  const container = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 20px",
  };

  const glass = {
    background: "rgba(255,255,255,0.02)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "24px",
    padding: "40px",
    backdropFilter: "blur(12px)",
  };

  const btnPrimary = {
    display: "inline-block", // Required for Link to behave like a button
    textDecoration: "none", // Remove default link underline
    padding: "16px 44px",
    borderRadius: "50px",
    background: "#00d4ff",
    color: "#05070a",
    border: "none",
    fontWeight: "800",
    cursor: "pointer",
    fontSize: "0.95rem",
    textTransform: "uppercase",
    letterSpacing: "1px",
    transition: "0.3s",
    boxShadow: "0 0 25px rgba(0,212,255,0.2)",
  };

  return (
    <div style={page}>
      {/* ================= HERO SECTION ================= */}
      <section style={container}>
        <div style={{ textAlign: "center", marginBottom: "90px" }}>
          <h4
            style={{
              color: "#00d4ff",
              letterSpacing: "4px",
              textTransform: "uppercase",
              marginBottom: "20px",
              fontWeight: "700",
              fontSize: "0.85rem",
            }}
          >
            INNOVATE • ELEVATE • ACCELERATE
          </h4>

          <h1
            style={{
              fontSize: "clamp(2.5rem, 6vw, 4.5rem)",
              fontWeight: "900",
              lineHeight: "1.1",
              marginBottom: "30px",
              letterSpacing: "-1px",
            }}
          >
            Global Technology Resources <br />
            <span style={{ color: "#00d4ff" }}>
              & Delivery Enablement Partner
            </span>
          </h1>

          <p
            style={{
              fontSize: "1.15rem",
              color: "#a0aab4",
              maxWidth: "850px",
              margin: "0 auto 45px",
              lineHeight: "1.8",
            }}
          >
            Digital-X-AI is an innovative technical partner providing gateway to
            uncovering abilities. We specialize in resource augmentation,
            enterprise software, and strategic execution — powered by delivery
            hubs in India and global project support.
          </p>

          <div
            style={{
              display: "flex",
              gap: "20px",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <Link
  to="/capabilities" // The route for your Capabilities.jsx page
  style={btnPrimary}
>
  Explore Capabilities
</Link>

            <Link
              to="/contact"
              style={{
                ...btnPrimary,
                background: "transparent",
                color: "#ffffff",
                border: "1px solid rgba(255,255,255,0.3)",
                boxShadow: "none",
              }}
            >
              Engage With Us
            </Link>
          </div>
        </div>

        <div
          style={{
            borderRadius: "32px",
            overflow: "hidden",
            border: "1px solid rgba(255,255,255,0.1)",
            marginBottom: "120px",
            boxShadow: "0 30px 60px rgba(0,0,0,0.5)",
          }}
        >
          <img
            src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1600&q=80"
            alt="Digital X Global Connectivity"
            style={{
              width: "100%",
              height: "500px",
              objectFit: "cover",
              opacity: 0.9,
            }}
          />
        </div>
      </section>

      {/* ================= MISSION & VALUES ================= */}
      <section
        style={{
          background: "#080a0e",
          padding: "100px 0",
          borderTop: "1px solid rgba(255,255,255,0.05)",
        }}
      >
        <div
          style={{
            ...container,
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
            gap: "40px",
          }}
        >
          <div style={glass}>
            <h3
              style={{
                color: "#00d4ff",
                marginBottom: "15px",
                textTransform: "uppercase",
                fontSize: "1rem",
                letterSpacing: "2px",
              }}
            >
              Mission
            </h3>
            <p
              style={{
                color: "#8b949e",
                fontSize: "0.95rem",
                lineHeight: "1.7",
              }}
            >
              To be a trusted partner delivering strategic vision to build
              organizations that attract and retain talent in India and globally.
            </p>
          </div>
          <div style={glass}>
            <h3
              style={{
                color: "#00d4ff",
                marginBottom: "15px",
                textTransform: "uppercase",
                fontSize: "1rem",
                letterSpacing: "2px",
              }}
            >
              Vision
            </h3>
            <p
              style={{
                color: "#8b949e",
                fontSize: "0.95rem",
                lineHeight: "1.7",
              }}
            >
              Creating a rich environment for collaboration to achieve exponentially
              stronger outcomes through collective knowledge.
            </p>
          </div>
          <div style={glass}>
            <h3
              style={{
                color: "#00d4ff",
                marginBottom: "15px",
                textTransform: "uppercase",
                fontSize: "1rem",
                letterSpacing: "2px",
              }}
            >
              Values
            </h3>
            <p
              style={{
                color: "#8b949e",
                fontSize: "0.95rem",
                lineHeight: "1.7",
              }}
            >
              Acting with complete honesty and transparency, being responsible and
              accountable in all our dealings.
            </p>
          </div>
        </div>
      </section>

      {/* ================= STRATEGIC HUB ================= */}
      <section style={{ ...container, padding: "120px 0" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "60px",
            alignItems: "center",
          }}
        >
          <div style={{ flex: "1 1 450px" }}>
            <h2
              style={{
                fontSize: "2.8rem",
                marginBottom: "25px",
                fontWeight: "800",
              }}
            >
              Technical <span style={{ color: "#00d4ff" }}>Subletting</span> & Support
            </h2>
            <p
              style={{
                color: "#8b949e",
                lineHeight: "1.9",
                fontSize: "1.1rem",
                marginBottom: "30px",
              }}
            >
              We provide skilled resources setup in India, readily available for
              deployment as a secondary layer for high-quality software delivery
              in the Middle East.
            </p>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "20px",
              }}
            >
              <div
                style={{
                  padding: "20px",
                  borderLeft: "3px solid #00d4ff",
                  background: "rgba(255,255,255,0.02)",
                }}
              >
                <h4 style={{ margin: "0 0 5px", fontSize: "0.9rem" }}>SAP Support</h4>
                <p style={{ margin: 0, fontSize: "0.8rem", color: "#8b949e" }}>
                  Enterprise implementation.
                </p>
              </div>
              <div
                style={{
                  padding: "20px",
                  borderLeft: "3px solid #00d4ff",
                  background: "rgba(255,255,255,0.02)",
                }}
              >
                <h4 style={{ margin: "0 0 5px", fontSize: "0.9rem" }}>Business Analysis</h4>
                <p style={{ margin: 0, fontSize: "0.8rem", color: "#8b949e" }}>
                  Tableau & Power BI.
                </p>
              </div>
            </div>
          </div>
          <div style={{ flex: "1 1 400px" }}>
            <img
              src="https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=800"
              alt="Professional Team"
              style={{ width: "100%", borderRadius: "24px", filter: "grayscale(20%)" }}
            />
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA ================= */}
      <section style={{ ...container, paddingBottom: "140px" }}>
        <div
          style={{
            background: "linear-gradient(135deg, #00d4ff 0%, #0080ff 100%)",
            borderRadius: "40px",
            padding: "80px 40px",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              fontSize: "2.6rem",
              color: "#05070a",
              fontWeight: "900",
              marginBottom: "15px",
            }}
          >
            Ready to Innovate Together?
          </h2>
          <p
            style={{
              color: "#05070a",
              fontWeight: "600",
              maxWidth: "600px",
              margin: "0 auto 40px",
              opacity: "0.8",
            }}
          >
            Engage with Digital-X-AI as your strategic delivery partner.
          </p>
          <Link
            to="/contact"
            style={{ ...btnPrimary, background: "#05070a", color: "#ffffff", boxShadow: "none" }}
          >
            Contact US
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;